import moment from 'moment'
import {
  formatarApontamentosParaLimitePorHorasTrabalhadas,
  formatarValorParaLimitePorHorasTrabalhadas,
  formatarJornadaBaseParaLimitePorHorasTrabalhadas
} from './limiteDeAcumuloPorHorasTrabalhadas'
import { formatarConfiguracoesAvancadas } from './configuracoesAvancadas'

function formataDataInicioDoBanco (state) {
  return moment(state.dataInicioDoBanco).toISOString()
}

function formataRazaoDeAcumuloECompensacao (state) {
  if (!state.usaRazaoDeAcumuloECompensacao) {
    return Array(10).fill(0)
  }
  return state.razaoDeAcumuloECompensacao.map(valor => {
    if (valor !== 0 && !valor) return 0
    return 1 - (valor / 100)
  })
}

function formataLimites (state, flagDeUsoDoLimite, nomeDoLimite) {
  const formataValoresDoLimite = (valor, indice) => {
    if (state[nomeDoLimite][indice] !== 0 && !state[nomeDoLimite][indice]) {
      return -1
    }
    return valor
  }

  const valorSemLimite = -1
  const flagDoLimiteNaoFoiSelecionada = state[flagDeUsoDoLimite]

  if (!flagDoLimiteNaoFoiSelecionada) return Array(10).fill(valorSemLimite)
  return state[nomeDoLimite].map(formataValoresDoLimite)
}

function converteValorDeFatorDeTransformacao (valor) {
  if (valor !== 0 && !valor) return 1
  return valor
}

function formatarCompensateOnLock (state) {
  const modalidadeDeBancoEhJanela = state.modalidadeDoBanco.selected.id === 'janela'

  return modalidadeDeBancoEhJanela
    ? state.compensateOnLock
    : true
}

export function formataObjetoParaEnviar (state) {
  const request = {
    // Cabeçalho
    nome: state.nome,
    codigo: state.codigo,
    inicioDoBh: formataDataInicioDoBanco(state),
    numeroDeDiasAteCompensacao: state.usaConfiguracaoDeVencimentoPorMeses ? 0 : state.limiteDeAcumuloDoBanco,
    numeroDeMesesParaCompensacao: state.usaConfiguracaoDeVencimentoPorMeses ? state.limiteDeMesesDeAcumuloDoBanco : 0,
    vencimentoUnificado: state.vencimentoUnificado,
    bhMovel: !state.usaConfiguracaoDeVencimentoPorMeses && state.tipoDeContagemDeTempo.selected.id === 'movel',
    autoCompensado: state.modalidadeDoBanco.selected.id === 'janela',
    mostrarDetalhesDasHoras: state.modalidadeDoBanco.selected.id !== 'janela',
    tipoDeJanela: state.tipoDoCicloDeAutoCompensacao.selected.id,
    cicloDeExpiracaoDaJanela: state.quantosCiclosParaVencimento,
    permitirAcumuloDescontoEmSaldosVencidos: state.modalidadeDoBanco.selected.id === 'janela'
      ? state.permitirDescontoEmSaldosVencidos
      : false,
    // FatorDeTransformacaoDeHoras
    compensationPerHourKind: state.fatorDeTransformacaoDeHoras.map(converteValorDeFatorDeTransformacao),
    // RazaoDeAcumuloECompensacao
    splitPerKindOfHour: formataRazaoDeAcumuloECompensacao(state),
    // CompensacaoEmOrdem
    compensacaoEmOrdem: state.usaCompensacaoEmOrdem,
    separarHorasExtrasDeSobreavisoNaCompensacaoEmOrdem: state.usaCompensacaoEmOrdem
      ? state.separarHorasExtrasDeSobreavisoNaCompensacaoEmOrdem
      : false,
    ordemDeAcumulos: state.usaCompensacaoEmOrdem
      ? state.tipoDeAcumuloDaBaixaDeBh.selected.map(criterio => criterio.id)
      : [],
    ordemDeCompensacoes: state.usaCompensacaoEmOrdem
      ? state.tipoDeCompensacaoDaBaixaDeBh.selected.map(criterio => criterio.id)
      : [],
    exibirBaixaDeBhSeparadaPorCategorias: state.usaCompensacaoEmOrdem
      ? state.exibirBaixaDeBhSeparadaPorCategorias
      : false,
    // LimitesDiarios
    dailyLimitPerHourKind: formataLimites(
      state, 'usaLimiteDiario', 'limiteDeAcumuloECompensacaoDiario'
    ),
    limiteDiarioInferiorPorTipoDeHora: formataLimites(
      state, 'usaLimiteDiario', 'limiteBaseDeAcumuloECompensacaoDiario'
    ),
    apontLimiteDeAcumuloHorasTrabDiaria: formatarApontamentosParaLimitePorHorasTrabalhadas(
      state.limiteDeAcumuloPorHorasTrabalhadas
    ),
    valorLimiteDeAcumuloHorasTrabDiaria: formatarValorParaLimitePorHorasTrabalhadas(
      state.limiteDeAcumuloPorHorasTrabalhadas
    ),
    jornadaBaseLimiteDeAcumuloHorasTrabDiaria: formatarJornadaBaseParaLimitePorHorasTrabalhadas(
      state.limiteDeAcumuloPorHorasTrabalhadas
    ),
    // LimitesSemanais
    limiteSemanalSuperiorPorTipoDeHora: formataLimites(
      state, 'usaLimiteSemanal', 'limiteDeAcumuloECompensacaoSemanal'
    ),
    limiteSemanalInferiorPorTipoDeHora: formataLimites(
      state, 'usaLimiteSemanal', 'limiteBaseDeAcumuloECompensacaoSemanal'
    ),
    // LimitesMensais
    monthlyLimitPerKindOfHora: formataLimites(
      state, 'usaLimiteMensal', 'limiteDeAcumuloECompensacaoMensal'
    ),
    limiteMensalInferiorPorTipoDeHora: formataLimites(
      state, 'usaLimiteMensal', 'limiteBaseDeAcumuloECompensacaoMensal'
    ),
    // LimitesMensaisSobreaviso
    gruposDeLimiteSobreaviso: state.usaLimiteMensalSobreaviso
      ? [
          ...state.limiteMensalSobreaviso
            .map((v, i) => (v !== null && v !== undefined && v !== 0 && v !== -1) ? { indices: [i], teto: v } : null)
            .filter(Boolean),
          ...state.gruposDeLimiteSobreaviso.map(g => ({
            indices: g.indices,
            teto: (g.teto !== 0 && !g.teto) ? null : g.teto
          }))
        ]
      : [],
    // LimitesGerais
    generalLimitPerKindOfHora: formataLimites(
      state, 'usaLimiteGeral', 'limiteDeAcumuloECompensacaoGeral'
    ),
    limiteGeralInferiorPorTipoDeHora: formataLimites(
      state, 'usaLimiteGeral', 'limiteBaseDeAcumuloECompensacaoGeral'
    ),
    // Aprovação automática
    estaAprovado: state.aprovacaoAutomatica,
    separarCompensacaoEAcumulo: state.separarCompensacaoEAcumulo,
    // OutrasConfiguracoes
    autoAcumularApontamentos: state.acumularHorasAutomaticamente,
    autoCompensarSomas: state.compensarHorasAutomaticamente,
    permitirBalancoNegativo: state.permitirBalancoNegativo,
    permitirAcumuloParcial: state.considerarAcumuloParcialDeHoras,
    considerarBaixaParcialComoCompensacao: state.considerarBaixaComTmsComoCompensacao,
    descontarBancoSemExibirNaFolha: state.descontarBancoSemExibirNaFolha,
    removeLineMeasurement: state.removerApontamentosDaLinha,
    compensarNoTravamento: formatarCompensateOnLock(state),
    fazerBaixaNoVencimentoDoBanco: state.fazerBaixaNoVencimentoDoBanco,
    completarVisualizacaoDoAcumuladoComJanelasFalsas: state.completarVisualizacaoDoAcumuladoComJanelasFalsas,
    manterSaldoMensal: state.mostrarHistoricoDosSaldosNoAcumuladoDeBancoDeHoras,
    mudaNomenclaturaParaCompensacaoNaFolha: state.mudaNomenclaturaParaCompensacaoNaFolha,
    exibirFaltaComoCompensadaNoR01: Boolean(state.exibirFaltaComoCompensadaNoR01),
    calcularLimitesUtilizandoSaldosFuturos: state.calcularLimitesUtilizandoSaldosFuturos,
    considerarHorasRelogioNoCalculoDeLimiteSemanal: state.considerarHorasRelogioNoCalculoDeLimiteSemanal,
    // ConfiguracoesAvancadas
    ...formatarConfiguracoesAvancadas(state),
    // ?
    todasAsHorasSaoConversiveis: true,
  }

  if (state.id) request.id = state.id

  return request
}
